import { BlogToolbar } from 'components/blog/blog-toolbar';

const BlogIndexHeader = ({ title = 'Latest from Playbooks' }) => {
	// Render
	return (
		<header className='hero-grid relative'>
			<div className='relative z-1 mx-auto max-w-6xl px-5 pt-12 sm:px-8 md:pt-16'>
				<div className='max-w-3xl pb-10 md:pb-12'>
					<p className='type-pretitle'>Playbooks Blog</p>
					<h1 className='type-display mt-4 text-balance'>{title}</h1>
					<p className='mt-4 max-w-2xl text-base leading-7 text-foreground-body md:text-lg'>
						Ideas and operating lessons for implementation partners building AI-native business capabilities.
					</p>
				</div>
			</div>
			<div className='relative z-1'>
				<BlogToolbar />
			</div>
		</header>
	);
};
export { BlogIndexHeader };
